exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#descriptionActiveContainer[data-v-6499bebf] {\n  height: 3%;\n}\n", ""]);

// exports
